module.exports = __webpack_public_path__ + "static/media/PATEL JI_page-0001.7e9efa92.jpg";